// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Injectable } from '@angular/core';

import { CounterConfig } from './interfaces/counter-config.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtmParams } from './ya-metric/utm-params.interface';

@Injectable({
  providedIn: 'root'
})
export class MetricService {
  constructor() {}

  private _utmParams: BehaviorSubject<UtmParams | null> = new BehaviorSubject<UtmParams | null>(null);
  utmParams$: Observable<UtmParams | null> = this._utmParams.asObservable();

  get utmParams(): UtmParams | null {
    this._utmParams.getValue();
  }
  setUtmParams(params: UtmParams){
    this._utmParams.next(params)
  }

  private yaCounters: any[] = [];

  runGA(codes: string[]): void {
    this.insertGA().then(ga => {
      codes.forEach(code => {
        ga('create', code, 'auto');
      });
      ga('send', 'pageview');
    })
  }

  runYAM(codes: string[]): void {
    this.insertYAMetrika().then(Ya => {
      codes.forEach(code => {
        if (code) {
          const config: CounterConfig = {id: code, ecommerce: 'iikoLayer', webvisor: true, defer: true};
          const counter = new Ya.Metrika2(config);
          this.yaCounters.push(counter);
          (window as any)['yaCounter_' + code] = counter;
        }
      });
      this.hitYandex(window.location.href, this.utmParams);
    });
  }

  runGTM(codes: string[]): void {
    codes.forEach(code => {
      this.loadScript('https://www.googletagmanager.com/gtag/js?id=' + code).then()
    })
  }

  private insertYAMetrika(): Promise<any> {
    return this.loadScript('https://mc.yandex.ru/metrika/tag.js').then(() => {
      return (window as any).Ya;
    });
  }

  private insertGA(): Promise<any> {
    // eslint-disable-next-line prefer-rest-params
    window.ga = window.ga || function() {(ga.q = ga.q || []).push(arguments)}; ga.l =+ new Date;
    return this.loadScript('https://www.google-analytics.com/analytics.js').then(() => {
      return (window as any).ga
    });
  }

  private loadScript(src: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const insertNode = document.getElementsByTagName('script')[0];
      const metricScriptTag = document.createElement('script');

      metricScriptTag.onload = resolve;
      metricScriptTag.onerror = reject;
      metricScriptTag.type = 'text/javascript';
      metricScriptTag.async = true;

      metricScriptTag.src = src;

      const insetScriptTag = (): void => insertNode.parentNode!.insertBefore(metricScriptTag, insertNode);

      if ((window as any).opera === '[object Opera]') {
        document.addEventListener('DOMContentLoaded', insetScriptTag, false);
      } else {
        insetScriptTag();
      }
    });
  }

  fireYandexGoal(goal: string): void {
    const ecommCounter = this.yaCounters[this.yaCounters.length - 1];
    if(!ecommCounter) {return}
    ecommCounter.reachGoal(goal);
  }

  hitYandex(url, utmParams: UtmParams | null): void {
    if(utmParams){
      const queryParams = new URLSearchParams(utmParams);
      url += '?' +  queryParams;
    }

    this.yaCounters.forEach(counter => {
      counter.hit(url)
    })
  }
}
